module.exports = __webpack_public_path__ + "img/icon_contact_us_static.d377d57.svg";